import Skeleton from 'react-loading-skeleton';

import { SettingsCard } from '@domains/settings/pages/SettingsPage/SettingsPage.styled';

import {
    SkeletonOption,
    SkeletonOptionWrapper,
    SkeletonTitle,
} from './OptionsSkeleton.styled';

export const OptionsSkeleton = () => {
    return (
        <SettingsCard>
            <SkeletonTitle>
                <Skeleton height={16} width={`100%`} />
            </SkeletonTitle>

            {[...Array(2).keys()].map((_, index) => (
                <SkeletonOptionWrapper key={index}>
                    <SkeletonOption>
                        <Skeleton height={16} width={`100%`} />
                    </SkeletonOption>
                    <SkeletonOption>
                        <Skeleton height={16} width={`100%`} />
                    </SkeletonOption>
                </SkeletonOptionWrapper>
            ))}
        </SettingsCard>
    );
};
